import React, {useState, getGlobal} from 'reactn';
import { Form, Input , Button} from 'antd';
import { useFirestore } from 'reactfire';
const { TextArea } = Input;

const SingleDisease = (props) => {

    const [state, setState] = useState({diseasename: props.diseasename});
    const firestore = useFirestore();
    const [loadingBtn, setLoadingBtn] = useState(false);
    const getValue = e => {
        setState({...state, note: e.target.value});
    }

    const addDisease = () => {
        setLoadingBtn(true);
        firestore.collection('Diagnosis_records').add({
            patient: firestore.collection("patients").doc(getGlobal().patientID),
            appointment: firestore.collection("appointments").doc(getGlobal().appointmentId),
            appointment_id: getGlobal().appointmentId,
            disease_info: state,
            timestamp: new Date(),
          }).then(() => {
            console.log('Successfully Added');
            props.recAdded();
            setLoadingBtn(false);
        });
    }

    return (
        <li>
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
                <h4>{state.diseasename}</h4>
            </div>
            <Form.Item
            style={{marginBottom: '10px'}}
            name="note"
            >
                <TextArea onChange={getValue} placeholder="Enter Note" rows={1} />
            </Form.Item>
            <Button type="primary" htmlType="submit" loading={loadingBtn} onClick={addDisease}>
                Add
            </Button>
        </li>
    );
}

export default SingleDisease;
